export var GOOGLE_API_KEY = 'AIzaSyBQJ0eXrGr5Mo1VHQpsMRHIlwZIDHZguDw';
export var biasAwayFromNYBounds = {
    north: 49.0,
    south: 24.0,
    east: -80.0, // roughly stops before NY
    west: -125.0,
};
export function parseAddress(place) {
    var _a, _b, _c, _d, _e, _f, _g;
    var components = {};
    (_a = place.address_components) === null || _a === void 0 ? void 0 : _a.forEach(function (c) {
        components[c.types[0]] = c.short_name;
    });
    return {
        street: "".concat((_b = components.street_number) !== null && _b !== void 0 ? _b : "", " ").concat((_c = components.route) !== null && _c !== void 0 ? _c : "").trim(),
        city: components.locality,
        state: components.administrative_area_level_1,
        zip: components.postal_code,
        lat: (_e = (_d = place.geometry) === null || _d === void 0 ? void 0 : _d.location) === null || _e === void 0 ? void 0 : _e.lat(),
        lng: (_g = (_f = place.geometry) === null || _f === void 0 ? void 0 : _f.location) === null || _g === void 0 ? void 0 : _g.lng(),
    };
}
